import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';

export const useLinkProductsToReservationsEnabled = () => useFeatureFlag(FeatureFlag.linkProductsToReservationsEnabled);
